import { useViewerStore, type QualityTier } from "../state/viewerStore";

const QUALITIES: QualityTier[] = ["low", "medium", "high", "ultra"];

export function SceneControls() {
  const quality = useViewerStore((s) => s.quality);
  const setQuality = useViewerStore((s) => s.setQuality);

  return (
    <div className="scene-controls">
      <div className="quality-switcher">
        {QUALITIES.map((q) => (
          <button
            key={q}
            className={q === quality ? "active" : ""}
            onClick={() => setQuality(q)}
          >
            {q}
          </button>
        ))}
      </div>
    </div>
  );
}
